import script from "./mobileMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileMenu.vue?vue&type=script&setup=true&lang=js"

import "./mobileMenu.vue?vue&type=style&index=0&id=baf8b488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baf8b488"]])

export default __exports__